import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { ControlledTextField } from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { dataBaseViewSchema } from './schema';
import { PasswordSave } from './types';
import useSavePwdForBI from './useSavePwdForBI';
import { Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import useGetUsernameForBIDB from './useGetUsernameForBIDB';
import Box from '@mui/material/Box';

const DatabaseView = () => {
  const { t } = useTranslation('common');

  const methods = useForm<PasswordSave>({
    defaultValues: dataBaseViewSchema(t).cast({
      password: '',
      retypePassword: ''
    }),
    resolver: yupResolver(dataBaseViewSchema(t))
  });

  const { handleSubmit, control } = methods;

  const { mutate, isLoading } = useSavePwdForBI();
  const { data: dbData } = useGetUsernameForBIDB();

  const onSubmit = (data) => {
    mutate(data);
  };

  return (
    <Box pt={3}>
      <MultiStepForm
        methods={methods}
        onSubmit={handleSubmit(onSubmit)}
        fixedHeight={false}
      >
        <MultiStepForm.Section
          fullWidth
          title={t('databaseBIUserSettings.title', {
            username: dbData?.username
          })}
        >
          <Typography>
            {t('databaseBIUserSettings.labelForPwdSaving')}
          </Typography>
          <ControlledTextField
            type="password"
            sx={{ width: '450px' }}
            control={control}
            label={t('password')}
            name="password"
          />
          <ControlledTextField
            type="password"
            sx={{ width: '450px' }}
            control={control}
            label={t('retypePassword')}
            name="retypePassword"
          />
        </MultiStepForm.Section>
        <LoadingButton
          sx={{ float: 'right' }}
          loading={isLoading}
          type="submit"
          variant="contained"
          autoFocus
          color="primary"
        >
          {t('save')}
        </LoadingButton>
      </MultiStepForm>
    </Box>
  );
};

export default DatabaseView;
